module.exports = __webpack_public_path__ + "media/img/private-venue/bg-cta-7305b6c2d6eb13656bc0f91ade09d29c.png";